export default __webpack_public_path__ + "static/media/2343.18c9c228.png";